import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { CreateCustomerButton } from './create-customer-button';
import { CreateLabelButton } from './create-label-button';
import { EditCustomerButton } from './edit-customer-button';
import messages from './messages';
import { NewOrderButton } from './new-order-button';
import ReusableGridButton from '../../../components/grid-header/reusable-grid-button';
import { prepareToOpenCombineCustomersModal } from '../../../store/customers/combine/customers.combine.actions';
import { prepareToOpenImportCustomersModal } from '../../../store/customers/import/customers.import.actions';
import Global from '../../../store/global-selectors';
import TagButton from '../customers-tag-button';

const COMBINE = 'Combine';
const IMPORT = 'Import';
const CREATE_LABEL = 'Create Label';
const TAG = 'Tag';
const CREATE_CUSTOMER = 'Create Customer';
const EDIT_CUSTOMER = 'Edit Customer';
const NEW_ORDER = 'New Order';

const ReusableGridButtonContainer = ({ id }) => {
  const dispatch = useDispatch();
  const selectedCustomerIds = useSelector(Global.selectSelectedCustomersIds);
  const selectedCustomersCount = useSelector(Global.selectSelectedCustomersCount);

  const areCustomersSelected = !!selectedCustomerIds.length;

  const { action, messageDescriptor, disable, theme } = useMemo(() => {
    const propsMap = {
      [COMBINE]: {
        messageDescriptor: messages.combine,
        action: prepareToOpenCombineCustomersModal,
        disable: !areCustomersSelected || selectedCustomersCount < 2,
      },
      [IMPORT]: {
        messageDescriptor: messages.import,
        action: prepareToOpenImportCustomersModal,
      },
    };
    return propsMap[id];
  }, [id, areCustomersSelected, selectedCustomersCount]);

  const actionHandler = useCallback(() => dispatch(action()), [dispatch, action]);

  return (
    <ReusableGridButton actionHandler={actionHandler} disable={disable} messageDescriptor={messageDescriptor} theme={theme ?? 'tertiary'} />
  );
};

ReusableGridButtonContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export const CustomerGridButtons = [
  {
    type: CreateCustomerButton,
    id: CREATE_CUSTOMER,
    requiredRender: true,
  },
  {
    type: EditCustomerButton,
    id: EDIT_CUSTOMER,
    requiredRender: true,
  },
  {
    type: CreateLabelButton,
    id: CREATE_LABEL,
    requiredRender: true,
  },
  {
    type: NewOrderButton,
    id: NEW_ORDER,
    requiredRender: true,
  },
  {
    type: TagButton,
    id: TAG,
    requiredRender: true,
  },
  // TODO: Re-enable when soft delete customer feature is ready - Greg S. 12/10/2025
  // {
  //   type: DeleteCustomerButton,
  //   id: DELETE_CUSTOMER,
  //   requiredRender: true,
  // },
  {
    type: ReusableGridButtonContainer,
    id: IMPORT,
    requiredRender: true,
  },
  {
    type: ReusableGridButtonContainer,
    id: COMBINE,
    requiredRender: true,
  },
];
